<div class="analysis-mode-switch" *ngIf="isAnalysisModeSwitchAvailable$ | async">
  <button
    type="button"
    class="analysis-mode-switch__option"
    [class.analysis-mode-switch__option--active]="isBottomUpModeActive$ | async"
    [attr.aria-pressed]="isBottomUpModeActive$ | async"
    (click)="selectAnalysisMode(AnalysisMode.BottomUp)"
  >Bottom-up</button>
  <button
    type="button"
    class="analysis-mode-switch__option"
    [class.analysis-mode-switch__option--active]="!(isBottomUpModeActive$ | async)"
    [attr.aria-pressed]="!(isBottomUpModeActive$ | async)"
    (click)="selectAnalysisMode(AnalysisMode.TopDown)"
  >Top-down</button>
</div>

<app-product-selector
  *ngIf="isProductSelectorVisible$ | async"
  class="block mt-2"
  [excludeProductIds]="(excludedProductIds$ | async)!"
></app-product-selector>

<p-dropdown
  class="block mt-2"
  [options]="(metricOptions$ | async) || []"
  [ngModel]="metricId$ | async"
  (onChange)="selectMetric($event)"
  optionLabel="label"
  optionValue="id"
  placeholder="Kennzahl wählen"
  styleClass="w-full"
  scrollHeight="250px"
  appendTo="body"
></p-dropdown>
